import { Option } from "../constants/common";
import { createMapper } from "../utils/utils";


const INSURANCE_TYPE: Option[] = [
  {
    value: "PRIMARY",
    label: "Primary Insurance",
  },
  {
    value: "SECONDARY",
    label: "Secondary Insurance",
  },
  {
    value: "TERTIARY",
    label: "Tertiary Insurance",
  },
  {
    value: "OTHER",
    label: "Other",
  },
];

export const ENTHNICITY_LIST: Option[] = [
  { value: "CENTRAL_AMERICAN", label: "Central American" },
  { value: "CUBAN", label: "Cuban" },
  { value: "DOMINICAN", label: "Dominican" },
  { value: "MEXICAN", label: "Mexican" },
  { value: "SOUTH_AMERICAN", label: "South American" },
  { value: "HISPANIC_OR_LATINO", label: "Hispanic or Latino" },
  { value: "NOT_HISPANIC_OR_LATINO", label: "Not Hispanic or Latino" },
  { value: "DECLINED_TO_SPECIFY", label: "Declined to Specify" },
];

export const RACE_LIST: Option[] = [
  { value: "AFRICAN_AMERICAN", label: "African American" },
  { value: "AMERICAN_INDIAN", label: "American Indian" },
  { value: "ASIAN", label: "Asian" },
  { value: "ASIAN_INDIAN", label: "Asian Indian" },
  { value: "OTHER_RACE", label: "Other Race" },
  {
    value: "AMERICAN_INDIAN_OR_ALASKA_NATIVE",
    label: "American Indian or Alaska Native",
  },
  { value: "BLACK_OR_AFRICAN_AMERICAN", label: "Black or African American" },
  { value: "WHITE", label: "White" },
  { value: "HISPANIC_OR_LATINO", label: "Hispanic or Latino" },
  {
    value: "NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER",
    label: "Native Hawaiian or Other Pacific Islander",
  },
  { value: "UNKNOWN", label: "Unknown" },
];

export const YES_NO_LIST: Option[] = [
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
];


export const RACE_MAPPER = createMapper(RACE_LIST);

export const ENTHNICITY_MAPPER = createMapper(ENTHNICITY_LIST);

export const INSURANCE_TYPE_MAPPER = createMapper(INSURANCE_TYPE);
